'use strict';

module.exports = /* @ngInject */ ["$httpProvider", function ($httpProvider) {
  $httpProvider.defaults.headers.post['Content-Type'] = 'application/json';
  $httpProvider.interceptors.push('authInterceptor');
}];



//////////////////
// WEBPACK FOOTER
// /app/~/redi-idp-web-lib/dist/infrastructure/httpConfig.js
// module id = 124
// module chunks = 0